module.exports = __webpack_public_path__ + "ukraine.svg?ce25837339826640e4c91b0d81eecac5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/ukraine.svg
// module id = 329
// module chunks = 10